import React, { useEffect, useState } from 'react';
import { supabase } from '../services/supabaseClient';
import { useAuth } from '../context/AuthContext';

const TestSupabase: React.FC = () => {
  const [connectionStatus, setConnectionStatus] = useState<string>('Checking...');
  const [session, setSession] = useState<any>(null);
  const { user, isAuthenticated } = useAuth();

  useEffect(() => {
    const checkConnection = async () => {
      try {
        // Test database connection
        const { data, error } = await supabase
          .from('profiles')
          .select('count')
          .limit(1);

        if (error) {
          setConnectionStatus(`Error: ${error.message}`);
        } else {
          setConnectionStatus('Connected successfully!');
        }

        // Get current session
        const { data: { session } } = await supabase.auth.getSession();
        setSession(session);
      } catch (error) {
        setConnectionStatus(`Error: ${error instanceof Error ? error.message : 'Unknown error'}`);
      }
    };

    checkConnection();
  }, []);

  return (
    <div className="p-4 max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">Supabase Connection Test</h1>
      
      <div className="bg-white p-4 rounded-lg shadow mb-4">
        <h2 className="text-xl font-semibold mb-2">Connection Status</h2>
        <p className={connectionStatus.includes('Error') ? 'text-red-500' : 'text-green-500'}>
          {connectionStatus}
        </p>
      </div>

      <div className="bg-white p-4 rounded-lg shadow mb-4">
        <h2 className="text-xl font-semibold mb-2">Authentication Status</h2>
        <p>Is Authenticated: {isAuthenticated ? 'Yes' : 'No'}</p>
        {user && (
          <div className="mt-2">
            <p>User ID: {user.id}</p>
            <p>Email: {user.email}</p>
            <p>Name: {user.name || 'Not set'}</p>
            <p>Role: {user.role || 'Not set'}</p>
          </div>
        )}
      </div>

      <div className="bg-white p-4 rounded-lg shadow">
        <h2 className="text-xl font-semibold mb-2">Session Info</h2>
        {session ? (
          <pre className="bg-gray-100 p-2 rounded overflow-auto">
            {JSON.stringify(session, null, 2)}
          </pre>
        ) : (
          <p>No active session</p>
        )}
      </div>
    </div>
  );
};

export default TestSupabase; 